export const Copy = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17 13.4V16.4C17 20.4 15.4 22 11.4 22H7.6C3.6 22 2 20.4 2 16.4V12.6C2 8.6 3.6 7 7.6 7H10.6"
        stroke="#414141"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0001 13.4H13.8001C11.4001 13.4 10.6001 12.6 10.6001 10.2V7L17.0001 13.4Z"
        stroke="#414141"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6001 2H15.6001"
        stroke="#414141"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 5C7 3.34 8.34 2 10 2H12.62"
        stroke="#414141"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9999 8V14.19C21.9999 15.74 20.7399 17 19.1899 17"
        stroke="#414141"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 8H19C16.75 8 16 7.25 16 5V2L22 8Z"
        stroke="#414141"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Whatsapp = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ?? 32}
      height={props?.height ?? 32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M0.681463 15.8086C0.680719 18.4972 1.38323 21.1224 2.71904 23.4363L0.553711 31.3423L8.6445 29.2209C10.8823 30.4391 13.3896 31.0775 15.9375 31.0776H15.9442C24.3554 31.0776 31.2023 24.2332 31.2059 15.8206C31.2075 11.7441 29.6214 7.91076 26.7396 5.02679C23.8584 2.14307 20.0265 0.554107 15.9436 0.552246C7.53145 0.552246 0.68506 7.39628 0.681587 15.8086"
        fill="url(#paint0_linear_3292_9743)"
      />
      <path
        d="M0.136619 15.8035C0.135751 18.5889 0.863441 21.308 2.24688 23.7048L0.00390625 31.8942L8.38481 29.6967C10.694 30.9558 13.294 31.6196 15.9395 31.6206H15.9464C24.6593 31.6206 31.7521 24.53 31.7558 15.8162C31.7573 11.5932 30.1142 7.62208 27.1295 4.63479C24.1444 1.64788 20.1754 0.00173643 15.9464 0C7.23194 0 0.140092 7.08961 0.136619 15.8035ZM5.12763 23.292L4.8147 22.7953C3.49922 20.7036 2.8049 18.2865 2.80589 15.8045C2.80874 8.56174 8.70319 2.66915 15.9513 2.66915C19.4614 2.67064 22.7601 4.03895 25.2412 6.52155C27.7222 9.0044 29.0874 12.3049 29.0866 15.8152C29.0833 23.058 23.1888 28.9513 15.9464 28.9513H15.9411C13.5829 28.9501 11.2701 28.3168 9.25315 27.12L8.77315 26.8353L3.79975 28.1393L5.12763 23.2919V23.292Z"
        fill="url(#paint1_linear_3292_9743)"
      />
      <path
        d="M11.9949 9.19662C11.699 8.53888 11.3876 8.52561 11.1061 8.51407C10.8757 8.50415 10.6122 8.5049 10.3491 8.5049C10.0856 8.5049 9.65758 8.604 9.29578 8.99904C8.93361 9.39445 7.91309 10.35 7.91309 12.2934C7.91309 14.237 9.32865 16.1152 9.52599 16.379C9.72357 16.6423 12.2588 20.7582 16.2739 22.3415C19.6108 23.6574 20.2899 23.3957 21.0141 23.3297C21.7385 23.264 23.3513 22.3744 23.6804 21.452C24.0097 20.5297 24.0097 19.7391 23.911 19.5739C23.8122 19.4093 23.5488 19.3105 23.1538 19.113C22.7586 18.9154 20.8165 17.9598 20.4545 17.8279C20.0923 17.6962 19.829 17.6305 19.5656 18.026C19.3021 18.4209 18.5456 19.3105 18.3151 19.5739C18.0847 19.838 17.8542 19.8708 17.4593 19.6733C17.064 19.4751 15.7918 19.0584 14.2825 17.7128C13.1081 16.6658 12.3153 15.3727 12.0849 14.9772C11.8544 14.5823 12.0602 14.3682 12.2583 14.1714C12.4358 13.9944 12.6534 13.7101 12.8511 13.4795C13.0481 13.2488 13.1138 13.0842 13.2456 12.8208C13.3774 12.5571 13.3114 12.3264 13.2128 12.1288C13.1138 11.9313 12.3462 9.97764 11.9949 9.19662Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3292_9743"
          x1="1533.16"
          y1="3079.56"
          x2="1533.16"
          y2="0.552246"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FAF38" />
          <stop offset="1" stop-color="#60D669" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3292_9743"
          x1="1587.6"
          y1="3189.42"
          x2="1587.6"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F9F9F9" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const Telegram = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ?? 32}
      height={props?.height ?? 32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M16 0C11.7575 0 7.685 1.68675 4.6875 4.68625C1.68691 7.68694 0.000831175 11.7565 0 16C0 20.2417 1.6875 24.3142 4.6875 27.3137C7.685 30.3132 11.7575 32 16 32C20.2425 32 24.315 30.3132 27.3125 27.3137C30.3125 24.3142 32 20.2417 32 16C32 11.7583 30.3125 7.68575 27.3125 4.68625C24.315 1.68675 20.2425 0 16 0Z"
        fill="url(#paint0_linear_3292_9738)"
      />
      <path
        d="M7.24262 15.8311C11.9076 13.7991 15.0176 12.4593 16.5726 11.8121C21.0176 9.96381 21.9401 9.64281 22.5426 9.63193C22.6751 9.62981 22.9701 9.66256 23.1626 9.81818C23.3226 9.94943 23.3676 10.1269 23.3901 10.2516C23.4101 10.3761 23.4376 10.6598 23.4151 10.8813C23.1751 13.4113 22.1326 19.5508 21.6026 22.3846C21.3801 23.5836 20.9376 23.9856 20.5101 24.0248C19.5801 24.1103 18.8751 23.4108 17.9751 22.8211C16.5676 21.8978 15.7726 21.3233 14.4051 20.4226C12.8251 19.3816 13.8501 18.8093 14.7501 17.8743C14.9851 17.6296 19.0801 13.9058 19.1576 13.5681C19.1676 13.5258 19.1776 13.3683 19.0826 13.2853C18.9901 13.2021 18.8526 13.2306 18.7526 13.2531C18.6101 13.2851 16.3626 14.7721 12.0026 17.7138C11.3651 18.1523 10.7876 18.3661 10.2676 18.3548C9.69762 18.3426 8.59762 18.0318 7.78012 17.7663C6.78012 17.4406 5.98262 17.2683 6.05262 16.7151C6.08762 16.4271 6.48512 16.1323 7.24262 15.8311Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3292_9738"
          x1="1600"
          y1="0"
          x2="1600"
          y2="3200"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2AABEE" />
          <stop offset="1" stop-color="#229ED9" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const Tiktok = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="32"
      viewBox="0 0 29 32"
      fill="none"
    >
      <path
        d="M20.9354 11.5224C22.9964 12.9949 25.5213 13.8614 28.2483 13.8614V8.61666C27.7321 8.61677 27.2174 8.56292 26.7125 8.456V12.5843C23.9857 12.5843 21.4612 11.718 19.3997 10.2456V20.9486C19.3997 26.3028 15.057 30.6429 9.70039 30.6429C7.70172 30.6429 5.84395 30.039 4.30078 29.0032C6.06211 30.8033 8.51838 31.9198 11.2357 31.9198C16.5928 31.9198 20.9356 27.5798 20.9356 22.2253V11.5224H20.9354ZM22.83 6.23112C21.7766 5.08099 21.085 3.59465 20.9354 1.95139V1.27686H19.48C19.8464 3.36535 21.096 5.14963 22.83 6.23112ZM7.68881 24.8946C7.10033 24.1235 6.78222 23.18 6.78365 22.2099C6.78365 19.7612 8.76997 17.7756 11.2206 17.7756C11.6772 17.7754 12.1312 17.8455 12.5665 17.9834V12.6214C12.0578 12.5518 11.5445 12.5221 11.0314 12.533V16.7065C10.5959 16.5684 10.1417 16.4984 9.68484 16.4988C7.2343 16.4988 5.24809 18.4841 5.24809 20.9332C5.24809 22.665 6.24086 24.1642 7.68881 24.8946Z"
        fill="#FF004F"
      />
      <path
        d="M19.3999 10.2455C21.4615 11.7179 23.9858 12.5842 26.7127 12.5842V8.45589C25.1906 8.13181 23.8432 7.33688 22.8301 6.23112C21.096 5.14952 19.8466 3.36524 19.4802 1.27686H15.6576V22.225C15.6488 24.6672 13.6659 26.6446 11.2206 26.6446C9.77971 26.6446 8.49949 25.9581 7.68879 24.8945C6.24106 24.1642 5.24818 22.6649 5.24818 20.9334C5.24818 18.4845 7.23439 16.4989 9.68493 16.4989C10.1544 16.4989 10.607 16.572 11.0315 16.7066V12.5331C5.7689 12.6418 1.53662 16.9395 1.53662 22.2252C1.53662 24.8637 2.59052 27.2557 4.30109 29.0034C5.84426 30.039 7.70192 30.6431 9.7007 30.6431C15.0574 30.6431 19.4 26.3027 19.4 20.9486V10.2456L19.3999 10.2455Z"
        fill="black"
      />
      <path
        d="M26.7127 8.45572V7.3397C25.3401 7.34178 23.9946 6.95759 22.8301 6.23106C23.861 7.35902 25.2183 8.13686 26.7127 8.45595V8.45572ZM19.4801 1.27669C19.4452 1.07714 19.4184 0.87626 19.3998 0.674538V0H14.1216V20.9484C14.1132 23.3903 12.1303 25.3677 9.68484 25.3677C8.99157 25.3688 8.30778 25.2067 7.6887 24.8947C8.4994 25.9581 9.77962 26.6444 11.2205 26.6444C13.6657 26.6444 15.6489 24.6673 15.6575 22.2251V1.2768H19.4801V1.27669ZM11.0317 12.533V11.3447C10.5907 11.2844 10.146 11.2542 9.70084 11.2544C4.3436 11.2544 0.000976562 15.5947 0.000976562 20.9484C0.000976562 24.305 1.70768 27.2631 4.30122 29.0031C2.59066 27.2555 1.53676 24.8634 1.53676 22.225C1.53676 16.9395 5.76892 12.6417 11.0317 12.533Z"
        fill="#00F2EA"
      />
    </svg>
  );
};
export const Facebook = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ?? 32}
      height={props?.height ?? 32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M32 16C32 7.1635 24.8365 0 16 0C7.1635 0 0 7.16337 0 16C0 23.986 5.851 30.6054 13.5 31.8056V20.625H9.4375V16H13.5V12.475C13.5 8.465 15.8888 6.25 19.5434 6.25C21.294 6.25 23.125 6.5625 23.125 6.5625V10.5H21.1075C19.1198 10.5 18.5 11.7334 18.5 12.9987V16H22.9375L22.2281 20.625H18.5V31.8056C26.149 30.6054 32 23.9861 32 16Z"
        fill="#1877F2"
      />
      <path
        d="M22.2281 20.625L22.9375 16H18.5V12.9987C18.5 11.7332 19.1199 10.5 21.1075 10.5H23.125V6.5625C23.125 6.5625 21.294 6.25 19.5434 6.25C15.8888 6.25 13.5 8.465 13.5 12.475V16H9.4375V20.625H13.5V31.8056C14.327 31.9352 15.1629 32.0002 16 32C16.8371 32.0002 17.673 31.9353 18.5 31.8056V20.625H22.2281Z"
        fill="white"
      />
    </svg>
  );
};
export const Twitter = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ?? 32}
      height={props?.height ?? 32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M28.724 9.47204C28.7435 9.75429 28.7435 10.0363 28.7435 10.321C28.7435 18.996 22.1393 29.001 10.0635 29.001V28.996C6.49602 29.001 3.00248 27.9792 0 26.0525C0.51875 26.115 1.04 26.1463 1.5625 26.1475C4.51928 26.1499 7.39101 25.1582 9.71625 23.3318C8.34624 23.3059 7.01857 22.8525 5.91886 22.0351C4.81915 21.2176 4.00238 20.077 3.58275 18.7725C4.567 18.9625 5.581 18.9233 6.547 18.6593C3.484 18.0405 1.2805 15.3495 1.2805 12.2243V12.141C2.19358 12.6497 3.21551 12.9315 4.26025 12.9628C1.375 11.0348 0.48625 7.19704 2.22825 4.19679C3.87647 6.22495 5.9329 7.88372 8.26396 9.06536C10.595 10.247 13.1486 10.9251 15.7587 11.0555C15.4986 9.93523 15.5371 8.76625 15.8704 7.66549C16.2038 6.56474 16.8203 5.57078 17.6583 4.78304C20.3025 2.29729 24.4613 2.42479 26.9468 5.06779C28.4171 4.77747 29.827 4.2384 31.116 3.47379C30.6259 4.99396 29.6003 6.28438 28.23 7.10504C29.5314 6.95159 30.8023 6.6031 32 6.07129C31.119 7.39069 30.0096 8.54232 28.724 9.47204Z"
        fill="#1D9BF0"
      />
    </svg>
  );
};
export const Instagram = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ?? 32}
      height={props?.height ?? 32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M24.5 0H7.5C3.35786 0 0 3.35786 0 7.5V24.5C0 28.6421 3.35786 32 7.5 32H24.5C28.6421 32 32 28.6421 32 24.5V7.5C32 3.35786 28.6421 0 24.5 0Z"
        fill="url(#paint0_radial_3292_9693)"
      />
      <path
        d="M24.5 0H7.5C3.35786 0 0 3.35786 0 7.5V24.5C0 28.6421 3.35786 32 7.5 32H24.5C28.6421 32 32 28.6421 32 24.5V7.5C32 3.35786 28.6421 0 24.5 0Z"
        fill="url(#paint1_radial_3292_9693)"
      />
      <path
        d="M16.0011 3.5C12.6064 3.5 12.1803 3.51488 10.847 3.5755C9.51625 3.6365 8.60787 3.84712 7.81313 4.15625C6.99088 4.4755 6.2935 4.90262 5.59875 5.59762C4.90338 6.2925 4.47625 6.98987 4.156 7.81175C3.846 8.60675 3.63512 9.5155 3.57525 10.8456C3.51562 12.179 3.5 12.6053 3.5 16.0001C3.5 19.395 3.515 19.8197 3.5755 21.153C3.63675 22.4837 3.84738 23.3921 4.15625 24.1869C4.47575 25.0091 4.90288 25.7065 5.59788 26.4013C6.2925 27.0966 6.98988 27.5247 7.8115 27.844C8.60687 28.1531 9.51537 28.3637 10.8459 28.4247C12.1792 28.4854 12.605 28.5002 15.9996 28.5002C19.3948 28.5002 19.8195 28.4854 21.1528 28.4247C22.4835 28.3637 23.3929 28.1531 24.1882 27.844C25.0101 27.5247 25.7065 27.0966 26.401 26.4013C27.0964 25.7065 27.5234 25.0091 27.8438 24.1873C28.151 23.3921 28.362 22.4835 28.4245 21.1532C28.4844 19.82 28.5 19.395 28.5 16.0001C28.5 12.6053 28.4844 12.1792 28.4245 10.8459C28.362 9.51512 28.151 8.60688 27.8438 7.81213C27.5234 6.98988 27.0964 6.2925 26.401 5.59762C25.7057 4.90237 25.0104 4.47525 24.1875 4.15637C23.3906 3.84712 22.4817 3.63638 21.151 3.5755C19.8176 3.51488 19.3931 3.5 15.9972 3.5H16.0011ZM14.8798 5.75262C15.2126 5.75213 15.584 5.75262 16.0011 5.75262C19.3388 5.75262 19.7342 5.76463 21.0522 5.8245C22.271 5.88025 22.9325 6.08388 23.3731 6.255C23.9565 6.4815 24.3724 6.75238 24.8096 7.19C25.2471 7.6275 25.5179 8.04412 25.745 8.6275C25.9161 9.0675 26.12 9.729 26.1755 10.9478C26.2354 12.2655 26.2484 12.6612 26.2484 15.9972C26.2484 19.3333 26.2354 19.7291 26.1755 21.0467C26.1198 22.2655 25.9161 22.927 25.745 23.3671C25.5185 23.9505 25.2471 24.3659 24.8096 24.8031C24.3721 25.2406 23.9568 25.5114 23.3731 25.738C22.933 25.9099 22.271 26.113 21.0522 26.1688C19.7345 26.2286 19.3388 26.2416 16.0011 26.2416C12.6634 26.2416 12.2677 26.2286 10.9501 26.1688C9.73137 26.1125 9.06987 25.9089 8.62887 25.7377C8.04562 25.5111 7.62887 25.2404 7.19137 24.8029C6.75387 24.3654 6.48312 23.9498 6.256 23.3661C6.08488 22.926 5.881 22.2645 5.8255 21.0457C5.76562 19.728 5.75362 19.3323 5.75362 15.9941C5.75362 12.6561 5.76562 12.2624 5.8255 10.9446C5.88125 9.72587 6.08488 9.06437 6.256 8.62375C6.48263 8.04037 6.75388 7.62375 7.1915 7.18625C7.629 6.74875 8.04562 6.47787 8.629 6.25087C9.06962 6.079 9.73137 5.87587 10.9501 5.81987C12.1032 5.76775 12.5501 5.75212 14.8798 5.7495V5.75262ZM22.6736 7.82812C21.8455 7.82812 21.1736 8.49938 21.1736 9.32763C21.1736 10.1558 21.8455 10.8276 22.6736 10.8276C23.5018 10.8276 24.1736 10.1558 24.1736 9.32763C24.1736 8.4995 23.5018 7.82762 22.6736 7.82762V7.82812ZM16.0011 9.58075C12.4561 9.58075 9.58187 12.455 9.58187 16.0001C9.58187 19.5452 12.4561 22.4181 16.0011 22.4181C19.5462 22.4181 22.4195 19.5452 22.4195 16.0001C22.4195 12.4551 19.546 9.58075 16.0009 9.58075H16.0011ZM16.0011 11.8334C18.3022 11.8334 20.1679 13.6988 20.1679 16.0001C20.1679 18.3013 18.3022 20.1669 16.0011 20.1669C13.6999 20.1669 11.8345 18.3013 11.8345 16.0001C11.8345 13.6988 13.6999 11.8334 16.0011 11.8334Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_3292_9693"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.5 34.4646) rotate(-90) scale(31.7144 29.4969)"
        >
          <stop stop-color="#FFDD55" />
          <stop offset="0.1" stop-color="#FFDD55" />
          <stop offset="0.5" stop-color="#FF543E" />
          <stop offset="1" stop-color="#C837AB" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_3292_9693"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-5.36012 2.30512) rotate(78.681) scale(14.1765 58.436)"
        >
          <stop stop-color="#3771C8" />
          <stop offset="0.128" stop-color="#3771C8" />
          <stop offset="1" stop-color="#6600FF" stop-opacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const CancelButton = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M20.0002 36.6666C29.1668 36.6666 36.6668 29.1666 36.6668 19.9999C36.6668 10.8333 29.1668 3.33325 20.0002 3.33325C10.8335 3.33325 3.3335 10.8333 3.3335 19.9999C3.3335 29.1666 10.8335 36.6666 20.0002 36.6666Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2832 24.7168L24.7165 15.2834"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.7165 24.7168L15.2832 15.2834"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Pattern = (props: any) => (
  <svg
    width="2394"
    height="243"
    viewBox="0 0 2394 243"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1413.15 243H20C8.954 243 0 234.046 0 223V12.3627C0 5.53496 5.53501 0 12.363 0C20.019 0 25.835 6.88867 24.55 14.4366L2.629 143.254C1.225 151.503 7.29101 159.146 15.643 159.652C19.845 159.907 23.852 158.108 27.395 155.835C33.971 151.616 43.161 149.238 52.881 149.827C60.552 150.293 67.2764 152.529 72.2384 155.87C77.6924 159.543 83.4217 163.762 89.9851 164.16C95.5963 164.501 100.952 162.043 105.881 159.34C112.268 155.838 120.642 153.935 129.45 154.469C137.123 154.934 143.849 157.171 148.811 160.514C154.263 164.187 159.991 168.405 166.552 168.803C172.162 169.143 177.515 166.687 182.443 163.984C188.83 160.481 197.205 158.577 206.016 159.111C213.688 159.576 220.414 161.813 225.376 165.156C230.829 168.83 236.557 173.048 243.119 173.446C248.729 173.787 254.083 171.33 259.01 168.628C265.398 165.124 273.772 163.221 282.583 163.755C292.51 164.357 300.852 167.925 305.84 173.016C308.242 175.468 311.207 177.575 314.633 177.783L318.793 178.035C321.422 178.195 323.749 176.348 324.191 173.752C325.251 167.52 334.434 168.296 334.434 174.617V192.102C334.434 195.766 337.404 198.737 341.069 198.737H346.651C350.588 198.737 354.186 196.663 357.389 194.374C362.18 190.952 369.027 188.811 376.63 188.811C383.472 188.811 389.703 190.546 394.373 193.388C398.697 196.019 403.337 198.737 408.399 198.737C413.46 198.737 418.101 196.019 422.425 193.388C427.095 190.546 433.326 188.811 440.169 188.811C447.012 188.811 453.242 190.546 457.912 193.387C462.237 196.019 466.878 198.737 471.941 198.737C477.004 198.737 481.645 196.019 485.97 193.387C490.64 190.546 496.87 188.811 503.712 188.811C510.554 188.811 516.785 190.546 521.455 193.387C525.78 196.019 530.421 198.737 535.484 198.737C540.546 198.737 545.187 196.019 549.512 193.387C554.182 190.546 560.412 188.811 567.254 188.811C574.096 188.811 580.327 190.546 584.997 193.387C589.322 196.019 593.963 198.737 599.026 198.737C604.089 198.737 608.73 196.019 613.055 193.387C617.725 190.546 623.955 188.811 630.798 188.811C637.64 188.811 643.871 190.546 648.541 193.388C652.865 196.019 657.505 198.737 662.567 198.737C667.628 198.737 672.269 196.019 676.593 193.388C681.263 190.546 687.494 188.811 694.337 188.811C702.81 188.811 710.345 191.471 715.141 195.599C717.179 197.354 719.639 198.737 722.329 198.737C728.698 198.737 732.721 191.891 729.622 186.327L693.132 120.807C688.887 113.183 690.074 103.687 696.065 97.3429L738.235 52.6954C741.452 49.2889 742.967 44.4832 745.834 40.7771C748.528 37.2946 753.186 34.4881 759.352 33.0688C767.586 31.1734 768.438 55.1833 779.871 46.1052C785.07 41.9767 791.894 39.6771 797.714 42.8727C802.646 45.5813 805.253 51.1755 804.155 56.6947L803.525 59.8558C802.858 63.2098 801.089 66.2133 799.131 69.0173C793.462 77.1368 792.651 87.0039 793.844 95.4001C795.465 106.793 807.708 121.746 813.881 131.458L835.641 165.686C839.383 171.572 846.066 174.912 853.019 174.373C859.766 173.85 865.57 169.299 871.151 165.472C875.918 162.205 882.377 159.972 889.808 159.395C898.739 158.702 907.338 160.538 913.932 164.047C918.763 166.617 924.023 168.864 929.479 168.441C936.138 167.924 941.862 163.437 947.352 159.632C952.13 156.321 958.634 154.055 966.126 153.474C975.057 152.781 983.657 154.617 990.252 158.126C995.082 160.696 1000.34 162.943 1005.8 162.52C1012.46 162.003 1018.18 157.515 1023.67 153.711C1028.45 150.4 1034.95 148.134 1042.45 147.553C1051.38 146.86 1059.98 148.696 1066.57 152.206C1071.4 154.776 1076.66 157.022 1082.11 156.599L1092.59 155.786C1092.77 155.772 1092.93 155.665 1093.01 155.502C1093.24 155.034 1093.88 155.231 1093.85 155.752L1089.41 219.828C1088.83 228.083 1095.26 235.147 1103.53 235.351C1108.07 235.463 1112.29 233.261 1116.03 230.699C1122.15 226.511 1130.81 223.992 1140.25 224.225C1148.3 224.424 1155.51 226.588 1160.88 229.993C1166.21 233.38 1171.9 237.04 1178.22 237.196C1184.15 237.343 1189.68 234.406 1194.8 231.417C1200.75 227.944 1208.63 225.915 1217.15 226.125C1225.19 226.324 1232.4 228.488 1237.77 231.893C1243.11 235.28 1248.79 238.94 1255.12 239.096C1261.04 239.242 1266.57 236.306 1271.69 233.319C1277.64 229.845 1285.52 227.815 1294.04 228.026C1302.09 228.224 1309.29 230.388 1314.66 233.793C1320 237.179 1325.69 240.839 1332.01 240.995C1337.94 241.142 1343.46 238.205 1348.58 235.216C1354.54 231.743 1362.42 229.714 1370.94 229.924C1378.75 230.117 1385.78 232.165 1391.1 235.405C1396.79 238.872 1402.79 242.744 1409.45 242.908L1413.15 243ZM2380.69 0C2372.55 0 2366.31 7.24585 2367.53 15.2977L2392.51 180.872C2393.31 186.174 2389.37 191.012 2384.01 191.3C2381.27 191.447 2378.67 190.279 2376.5 188.599C2369.96 183.527 2359.98 180.521 2349.28 181.096C2341.53 181.512 2334.71 183.739 2329.67 187.097C2324.24 190.714 2318.52 194.821 2312 195.172C2306.33 195.477 2300.94 192.931 2295.98 190.175C2289.67 186.676 2281.39 184.746 2272.64 185.217C2264.88 185.634 2258.06 187.859 2253.02 191.217C2247.59 194.834 2241.87 198.942 2235.35 199.293C2229.68 199.598 2224.29 197.052 2219.33 194.296C2213.03 190.796 2204.74 188.866 2195.97 189.337C2188.23 189.753 2181.42 191.977 2176.38 195.332C2170.94 198.952 2165.22 203.063 2158.7 203.414C2153.02 203.719 2147.63 201.172 2142.66 198.415C2136.36 194.918 2128.08 192.99 2119.33 193.46C2110.71 193.923 2103.25 196.622 2098.1 200.625C2093.93 203.869 2089.33 207.144 2084.05 207.428C2076.22 207.849 2069.34 202.248 2068.17 194.487L2061.19 148.215C2059.04 133.952 2038.08 135.229 2037.68 149.648L2037.61 151.866C2037.47 157.079 2033.17 161.215 2027.96 161.163C2024.83 161.132 2022 159.482 2019.69 157.388C2014.03 152.269 2004.94 148.909 1994.6 148.806C1986.23 148.723 1978.54 150.795 1972.77 154.25C1967.58 157.358 1961.99 160.506 1955.93 160.445C1949.72 160.384 1944.07 156.946 1938.79 153.677C1933.26 150.25 1925.85 148.122 1917.65 148.04C1909.28 147.957 1901.59 150.029 1895.82 153.484C1890.63 156.591 1885.04 159.739 1878.98 159.678C1872.77 159.617 1867.12 156.178 1861.84 152.909C1856.31 149.481 1848.9 147.353 1840.7 147.272C1832.32 147.188 1824.64 149.263 1818.86 152.72C1813.67 155.827 1808.09 158.972 1802.04 158.912L1798.17 158.873C1794.38 158.835 1791.4 157.326 1788.55 154.828C1782.47 149.493 1774.25 156.034 1775.46 164.036L1778.08 181.427C1779.04 187.772 1774.32 193.561 1767.92 193.906C1764.64 194.082 1761.52 192.685 1758.93 190.675C1751.11 184.606 1739.16 181.01 1726.36 181.698C1716.49 182.229 1707.88 185.214 1701.76 189.675C1696.15 193.761 1690.09 198.091 1683.16 198.463L1680.54 198.604C1674.52 198.928 1668.8 196.249 1663.61 193.161C1655.95 188.596 1645.61 186.038 1634.64 186.628C1624.76 187.159 1616.14 190.151 1610.01 194.62C1604.42 198.703 1598.36 203.022 1591.45 203.394L1588.82 203.535C1582.8 203.859 1577.08 201.18 1571.89 198.091C1564.23 193.526 1553.89 190.967 1542.92 191.557C1533.04 192.088 1524.43 195.077 1518.3 199.544C1512.7 203.629 1506.65 207.953 1499.73 208.326L1497.1 208.467C1491.08 208.791 1485.36 206.112 1480.17 203.023C1472.51 198.459 1462.17 195.9 1451.2 196.49C1436.84 197.262 1425.15 203.222 1419.91 211.363C1419.4 212.151 1418.57 212.689 1417.63 212.74C1416.27 212.813 1415.17 213.891 1415.08 215.253L1413.15 243H2374C2385.05 243 2394 234.046 2394 223V13.3117C2394 5.95982 2388.04 0 2380.69 0Z"
      fill={props?.color}
    />
  </svg>
);

export const Logo = (props: any) => {
  return (
    <svg
      width={props?.width ?? 120}
      height={props?.height ?? 20}
      viewBox={`0 0 ${props?.width ?? 120} ${props?.height ?? 20}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.24 4.78C8.54667 4.78 9.61333 5.26667 10.44 6.24C11.2667 7.2 11.68 8.46667 11.68 10.04C11.68 11.6 11.26 12.8667 10.42 13.84C9.58 14.8 8.5 15.28 7.18 15.28C6.43333 15.28 5.78 15.1133 5.22 14.78C4.67333 14.4333 4.28667 14.0133 4.06 13.52V15H0.14V0.96H4.06V6.54C4.28667 6.03333 4.68 5.61333 5.24 5.28C5.81333 4.94667 6.48 4.78 7.24 4.78ZM4.42 11.58C4.76667 11.9667 5.21333 12.16 5.76 12.16C6.30667 12.16 6.75333 11.96 7.1 11.56C7.44667 11.16 7.62 10.6533 7.62 10.04C7.62 9.41333 7.44667 8.90667 7.1 8.52C6.75333 8.13333 6.30667 7.94 5.76 7.94C5.21333 7.94 4.76667 8.13333 4.42 8.52C4.07333 8.90667 3.9 9.41333 3.9 10.04C3.9 10.6667 4.07333 11.18 4.42 11.58ZM16.8055 15.28C15.5521 15.28 14.6255 14.9133 14.0255 14.18C13.4388 13.4467 13.1455 12.4267 13.1455 11.12V5.06H17.1255V10.26C17.1255 11.42 17.5721 12 18.4655 12C19.4121 12 19.8855 11.38 19.8855 10.14V5.06H23.8255V15H19.8855V13.52C19.3655 14.6933 18.3388 15.28 16.8055 15.28ZM32.7575 5.06H36.6775V14.34C36.6775 15.9533 36.1775 17.18 35.1775 18.02C34.2575 18.7667 32.9508 19.14 31.2575 19.14C29.4708 19.14 28.1508 18.8 27.2975 18.12C26.9108 17.8 26.5908 17.4 26.3375 16.92C26.0975 16.4533 25.9775 15.9733 25.9775 15.48H29.8975C29.9375 16.16 30.3908 16.5 31.2575 16.5C32.2575 16.5 32.7575 15.9667 32.7575 14.9V13.08C32.1975 14.2133 31.1642 14.78 29.6575 14.78C27.2042 14.78 25.9775 13.3667 25.9775 10.54V5.06H29.8975V10.08C29.8975 11.24 30.3508 11.82 31.2575 11.82C32.2575 11.82 32.7575 11.1333 32.7575 9.76V5.06ZM38.9486 15V5.06H42.8686V6.52C43.3486 5.36 44.3286 4.78 45.8086 4.78C47.3686 4.78 48.4019 5.40667 48.9086 6.66C49.1886 6.07333 49.6153 5.61333 50.1886 5.28C50.7619 4.94667 51.4219 4.78 52.1686 4.78C54.5019 4.78 55.6686 6.16 55.6686 8.92V15H51.6686V9.64C51.6686 8.58667 51.2886 8.06 50.5286 8.06C49.6886 8.06 49.2686 8.71333 49.2686 10.02V15H45.2686V9.64C45.2686 9.08 45.1753 8.68 44.9886 8.44C44.8153 8.18667 44.5353 8.06 44.1486 8.06C43.7219 8.06 43.4019 8.21333 43.1886 8.52C42.9753 8.81333 42.8686 9.31333 42.8686 10.02V15H38.9486ZM68.3548 9.52C68.3548 10.0133 68.3215 10.5 68.2548 10.98H60.9348C60.9615 11.5 61.1415 11.9067 61.4748 12.2C61.8215 12.4933 62.2748 12.64 62.8348 12.64C63.6748 12.64 64.1948 12.3933 64.3948 11.9H68.1948C68.0215 12.9533 67.4482 13.7933 66.4748 14.42C65.5015 15.0333 64.2882 15.34 62.8348 15.34C61.0215 15.34 59.5948 14.88 58.5548 13.96C57.5282 13.0267 57.0148 11.72 57.0148 10.04C57.0148 8.38667 57.5348 7.08667 58.5748 6.14C59.6148 5.18 61.0082 4.7 62.7548 4.7C64.4082 4.7 65.7548 5.14667 66.7948 6.04C67.8348 6.93333 68.3548 8.09333 68.3548 9.52ZM60.9348 8.82H64.4348C64.4215 8.27333 64.2682 7.84667 63.9748 7.54C63.6815 7.23333 63.2615 7.08 62.7148 7.08C62.1815 7.08 61.7548 7.24 61.4348 7.56C61.1282 7.88 60.9615 8.3 60.9348 8.82Z"
        fill="white"
      />
      <path
        d="M71.7684 4.72C71.1418 4.72 70.6218 4.51333 70.2084 4.1C69.7951 3.67333 69.5884 3.16667 69.5884 2.58C69.5884 1.98 69.7951 1.47333 70.2084 1.06C70.6218 0.646666 71.1418 0.439999 71.7684 0.439999C72.3818 0.439999 72.8951 0.646666 73.3084 1.06C73.7351 1.47333 73.9484 1.98 73.9484 2.58C73.9484 3.16667 73.7351 3.67333 73.3084 4.1C72.8951 4.51333 72.3818 4.72 71.7684 4.72ZM70.0484 18.92C69.4618 18.92 68.9151 18.8467 68.4084 18.7V15.96C68.6484 16 68.8618 16.02 69.0484 16.02C69.5551 16.02 69.8084 15.72 69.8084 15.12V5.06H73.7284V15.24C73.7284 16.48 73.4151 17.4067 72.7884 18.02C72.1618 18.6333 71.2484 18.9333 70.0484 18.92ZM80.9394 15.34C79.1927 15.34 77.7927 14.8533 76.7394 13.88C75.686 12.8933 75.1594 11.6067 75.1594 10.02C75.1594 8.43333 75.686 7.15333 76.7394 6.18C77.7927 5.19333 79.1927 4.7 80.9394 4.7C82.6994 4.7 84.106 5.19333 85.1594 6.18C86.2127 7.15333 86.7394 8.43333 86.7394 10.02C86.7394 11.6067 86.2127 12.8933 85.1594 13.88C84.106 14.8533 82.6994 15.34 80.9394 15.34ZM80.9394 12.12C81.5127 12.12 81.966 11.9267 82.2994 11.54C82.6327 11.1533 82.7994 10.6467 82.7994 10.02C82.7994 9.39333 82.6327 8.88667 82.2994 8.5C81.966 8.11333 81.5127 7.92 80.9394 7.92C80.3794 7.92 79.926 8.12 79.5794 8.52C79.246 8.90667 79.0794 9.40667 79.0794 10.02C79.0794 10.6333 79.246 11.14 79.5794 11.54C79.926 11.9267 80.3794 12.12 80.9394 12.12ZM88.1869 15V0.999999H92.1069V15H88.1869ZM94.3783 15V0.999999H98.2983V15H94.3783ZM105.51 15.34C103.763 15.34 102.363 14.8533 101.31 13.88C100.256 12.8933 99.7297 11.6067 99.7297 10.02C99.7297 8.43333 100.256 7.15333 101.31 6.18C102.363 5.19333 103.763 4.7 105.51 4.7C107.27 4.7 108.676 5.19333 109.73 6.18C110.783 7.15333 111.31 8.43333 111.31 10.02C111.31 11.6067 110.783 12.8933 109.73 13.88C108.676 14.8533 107.27 15.34 105.51 15.34ZM105.51 12.12C106.083 12.12 106.536 11.9267 106.87 11.54C107.203 11.1533 107.37 10.6467 107.37 10.02C107.37 9.39333 107.203 8.88667 106.87 8.5C106.536 8.11333 106.083 7.92 105.51 7.92C104.95 7.92 104.496 8.12 104.15 8.52C103.816 8.90667 103.65 9.40667 103.65 10.02C103.65 10.6333 103.816 11.14 104.15 11.54C104.496 11.9267 104.95 12.12 105.51 12.12ZM118.46 3.48C117.634 3.48 117.22 3.81333 117.22 4.48V5.06H119.28V8.06H117.22V15H113.32V8.06H111.74V5.06H113.32V4.52C113.32 3.82667 113.427 3.22667 113.64 2.72C113.867 2.2 114.174 1.80667 114.56 1.54C114.947 1.26 115.36 1.06 115.8 0.94C116.24 0.82 116.72 0.76 117.24 0.76C118.08 0.76 118.76 0.846666 119.28 1.02V3.56C118.854 3.50667 118.58 3.48 118.46 3.48Z"
        fill="#EFA92F"
      />
    </svg>
  );
};

export const EurekaIcon = (props: any) => {
  return (
    <svg
      width="61"
      height="54"
      viewBox="0 0 61 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props?.className}
    >
      <path
        d="M52.1476 0.309667C54.2737 2.23225 55.2123 4.69925 55.7152 7.49812C56.9384 14.2033 58.4058 20.8748 59.6488 27.5771C60.0402 29.8074 60.2733 32.0504 60.342 34.2928C60.4151 36.3477 59.3262 37.727 57.7761 38.016C56.1636 38.3036 54.5217 37.3302 54.0414 35.2426C53.2477 31.8018 52.7846 28.2898 52.1331 24.8162C51.1623 19.5417 50.0459 14.3033 49.2165 9.03219C48.7198 5.97022 49.2191 2.94831 51.0487 0.303382L52.1476 0.309667ZM0.273306 41.6227C1.58134 43.9108 3.34384 45.7656 5.82343 46.6568C12.2278 48.967 18.6773 51.1762 25.1682 53.3042C26.4383 53.7192 27.7974 53.8534 29.1204 53.7038C29.9981 53.5995 31.2326 52.8786 31.4534 52.1698C31.6968 51.3398 31.136 50.1485 30.67 49.2622C30.396 48.7457 29.6539 48.4024 29.0518 48.1249C21.8521 44.9404 14.6345 41.818 6.86448 40.3507C4.78114 39.9559 2.49045 40.6749 0.290674 40.8893L0.273306 41.6227ZM18.6334 17.8764C22.2103 23.841 25.6241 29.8873 30.7067 34.792C31.9196 35.9592 32.8183 37.4677 33.9465 38.7349C34.9564 39.8578 35.9653 41.0202 37.1816 41.9045C38.2617 42.7033 39.6221 42.7783 40.7037 41.7049C41.7215 40.6893 41.6494 39.4273 41.0079 38.3099C39.6393 35.938 38.3385 33.4854 36.6616 31.3497C33.2876 27.0976 29.7055 23.0215 26.1867 18.9107C24.8037 17.2887 23.4008 15.6695 21.9538 14.1085C20.8242 12.9005 19.5249 11.9122 17.6132 12.0512C17.0124 14.2152 17.5793 16.1206 18.6334 17.8764Z"
        fill="#E89A12"
      />
    </svg>
  );
};

export const Messages = (props: any) => {
  return (
    <svg
      width="48"
      height="40"
      viewBox="0 0 48 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props?.className}
    >
      <g clipPath="url(#clip0_2742_9526)">
        <path
          d="M8.13916 8.09192C12.474 7.41363 16.7839 7.164 21.0334 7.23767C23.4254 7.27917 25.8103 7.36884 28.2182 7.31174C28.3527 7.30857 28.754 7.2797 28.618 7.32493C25.3435 8.41429 22.1008 9.6855 18.8448 10.9692C18.0045 11.3005 10.596 13.2833 9.5414 14.8415C9.00861 15.6286 10.8608 15.5609 11.6075 15.6486C16.9875 16.2804 22.1725 17.911 27.5851 18.3335C30.0372 18.5248 24.984 19.9682 24.1851 20.3052C23.5916 20.5555 18.1316 21.7662 18.6323 23.0422C19.2344 24.5761 21.3499 25.5593 22.474 26.3261C24.7741 27.8949 27.1873 29.0868 29.7224 30.1742C30.9782 30.713 32.1817 31.5836 33.5583 31.3448"
          stroke="#FFF384"
          strokeWidth="12"
          strokeLinecap="round"
        />
        <path
          d="M11.783 1.26987L35.1898 12.3382C37.328 13.3494 38.2828 15.8712 37.3503 18.0448L33.336 27.4028C32.379 29.6338 29.7946 30.6666 27.5635 29.7096L22.312 27.4568L18.1382 30.5979C16.5281 31.8095 14.2091 30.8413 13.9388 28.8445L13.2229 23.5578L9.41165 21.9229C7.51029 21.1073 6.43508 19.0761 6.82958 17.0452L8.92431 6.26145"
          stroke="#020044"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <mask
          id="mask0_2742_9526"
          maskUnits="userSpaceOnUse"
          x="14"
          y="9"
          width="15"
          height="16"
        >
          <path
            d="M28.5741 13.9732L18.4751 9.64101L14.1429 19.74L24.2419 24.0722L28.5741 13.9732Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_2742_9526)">
          <path
            d="M26.9479 14.579C26.6801 14.3879 26.3819 14.2479 26.0694 14.1393C25.11 13.8058 24.1701 13.7534 23.2486 13.9721C23.1993 14.0014 23.1415 14.0134 23.0844 14.0065C23.0402 14.013 22.9936 14.0172 22.9471 14.024C22.8675 13.9174 22.8676 13.8358 22.8863 13.7513C22.8701 13.5711 22.8802 13.3906 22.8759 13.2098C22.8716 13.029 22.8346 12.8507 22.8063 12.6713C22.7977 12.647 22.7889 12.6227 22.7791 12.5994C22.7235 12.4594 22.6718 12.3195 22.6153 12.1797C22.472 11.819 22.2271 11.5168 21.8869 11.2712C21.5041 10.9938 21.087 10.7748 20.6523 10.5772C19.9001 10.234 18.6668 10.2862 18.0732 11.0392C17.8176 11.3591 17.6016 11.7085 17.4299 12.08C17.1997 12.5862 17.0996 13.1342 17.0038 13.6825C16.9342 14.0813 16.8802 14.484 16.8029 14.8808C16.6905 15.4567 16.6337 16.0422 16.6333 16.6292C16.6327 17.3795 16.7536 18.1419 16.7427 18.8878C16.7373 19.2526 16.8399 19.625 16.9651 19.9835C17.0643 20.2655 17.1387 20.5471 17.3068 20.8126C17.4508 21.0388 17.6576 21.2476 17.9188 21.3616C18.229 21.4972 18.5788 21.4865 18.8895 21.4184C19.6426 21.2531 20.315 20.9246 21.0115 20.6536C21.0122 20.6481 21.0128 20.6429 21.0132 20.6371C21.0144 20.6107 21.0683 20.588 21.1035 20.571C21.7125 20.2694 22.3222 19.9686 22.9326 19.6687C23.102 19.586 23.2815 19.5175 23.4522 19.4366C24.0217 19.167 24.5539 18.8472 25.0884 18.5312C25.633 18.2099 26.1704 17.8792 26.6435 17.4778C27.0035 17.1723 27.3145 16.832 27.5213 16.4189C27.8595 15.7427 27.7266 15.1346 26.9479 14.579Z"
            fill="#020044"
          />
        </g>
        <path
          d="M42.1089 10.4701L45.1121 8.44049"
          stroke="#06D4AE"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.2383 16.1402L45.7547 16.627"
          stroke="#06D4AE"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.0937 7.61873L36.6602 4.50198"
          stroke="#06D4AE"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2742_9526">
          <rect width="47.033" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Line = (props: any) => {
  return (
    <svg
      width="413"
      height="25"
      viewBox="0 0 413 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props?.className}
    >
      <path
        d="M89.8868 5.0906C129.117 4.35838 168.369 3.88767 207.621 3.67847C246.873 3.46926 285.762 3.539 324.822 3.87024C347.011 4.06201 369.221 4.32351 391.409 4.67219L394.421 1.09827C343.765 1.81305 293.13 2.70218 242.495 3.76563C191.861 4.82909 141.226 6.06689 90.5915 7.49646C62.1669 8.29841 33.7637 9.13523 5.33913 10.0418C3.67338 10.0941 1.17475 10.4428 0.235095 11.7677C-0.640493 13.0055 0.982549 13.6506 2.32796 13.6157C55.0982 12.5174 107.911 12.4128 160.703 13.3193C213.494 14.2259 266.243 16.161 318.928 19.0899C348.527 20.7287 378.105 22.6987 407.64 24.9825C409.242 25.1045 411.89 24.4595 412.744 23.2566C413.684 21.949 411.932 21.4958 410.651 21.4086C358.094 17.3465 305.41 14.2782 252.682 12.221C199.955 10.1638 147.142 9.13523 94.3502 9.1178C64.6869 9.1178 35.0237 9.41417 5.36049 10.0418L2.34932 13.6157C52.9626 11.9944 103.597 10.5648 154.232 9.29213C204.866 8.0369 255.501 6.93858 306.136 6.03202C334.56 5.52644 363.006 5.05573 391.431 4.65476C393.097 4.63732 395.617 4.23635 396.535 2.92881C397.453 1.62128 395.766 1.09827 394.442 1.08084C355.169 0.488089 315.938 0.12198 276.686 0.0348117C237.434 -0.0523571 198.545 0.104547 159.485 0.54039C137.297 0.784463 115.087 1.1157 92.898 1.53411C91.2322 1.56898 88.7122 1.95252 87.7939 3.26006C86.9183 4.49785 88.5414 5.1429 89.8868 5.10803V5.0906Z"
        fill="#E89A12"
      />
    </svg>
  );
};

export const Blob = (props: any) => {
  return (
    <svg
      width="102"
      height="100"
      viewBox="0 0 102 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props?.className}
    >
      <path
        d="M100.698 38.6269C95.8107 50.8359 80.9871 53.6914 73.2344 63.5925C65.8785 72.9798 63.0145 85.4753 52.2265 92.4649C27.0117 108.808 6.34636 94.6236 2.44628 86.8336C-6.5222 68.8797 11.7234 53.9085 16.2017 44.7263C19.8508 37.2568 16.6341 28.5088 15.4963 20.2745C14.372 12.0284 17.1903 1.7729 26.2164 0.195912C34.0267 -1.1742 41.1537 4.88957 46.1322 10.6685C51.1125 16.4592 56.7048 23.1402 64.7187 23.8592C73.8245 24.6714 81.8959 17.1324 90.8644 18.9146C99.7549 20.6849 103.687 31.1354 100.698 38.6269Z"
        fill="#EFA92F"
      />
    </svg>
  );
};
export const Arrow = (props: any) => {
  return (
    <svg
      width={props?.width || 199}
      height={props?.height || 152}
      viewBox="0 0 199 152"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props?.className}
    >
      <g clipPath="url(#clip0_2917_9859)">
        <path
          d="M37.4654 147.704C42.1046 123.509 51.9029 100.935 65.672 81.6956C79.4412 62.4557 96.6924 46.7932 116.656 35.7887C127.997 29.5314 140.002 25.0789 152.543 21.9713C153.825 21.6492 155.344 20.4144 155.777 19.0732C156.125 17.9597 155.495 16.9544 154.281 17.2348C130.581 22.4797 108.547 34.3167 89.872 50.0808C71.326 65.7455 55.917 85.8295 45.3185 108.647C39.3599 121.477 34.9064 135.186 32.2186 149.395C31.9443 150.861 33.4449 150.931 34.3676 150.663C35.5737 150.313 37.1889 149.117 37.48 147.699L37.4654 147.704Z"
          fill="black"
        />
        <path
          d="M124.948 18.0503C131.707 16.6048 138.505 15.3624 145.352 14.355C148.708 13.8663 152.079 13.4258 155.454 13.0386C157.205 12.8406 158.962 12.6586 160.709 12.4979C161.95 12.3883 163.044 12.1859 164.094 13.1708L165.395 9.57848C154.606 17.085 144.892 26.3065 136.824 37.0436C136.174 37.9023 135.836 39.2822 137.17 39.6267C138.505 39.9712 140.183 38.627 140.957 37.6529C148.568 27.9052 157.318 19.3993 167.251 12.4448C168.158 11.803 169.853 10.0381 168.553 8.85249C166.337 6.83313 162.46 7.93738 159.995 8.20479C156.364 8.60955 152.73 9.05155 149.125 9.57387C141.77 10.6324 134.471 11.942 127.213 13.508C125.827 13.8126 124.295 14.637 123.649 16.071C123.175 17.156 123.626 18.3504 124.939 18.0714L124.948 18.0503Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2917_9859">
          <rect
            width="175.515"
            height="98.8685"
            fill="white"
            transform="translate(0 57.9597) rotate(-19.2826)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Connectivity = (props: any) => {
  return (
    <svg
      width={props?.width || 40}
      height={props?.height || 40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props?.className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 6.72898C18.5548 6.72898 17.3832 7.90056 17.3832 9.3458H10.6542C10.6542 4.18426 14.8385 0 20 0C25.1616 0 29.3458 4.18426 29.3458 9.3458C29.3458 14.5073 25.1616 18.6916 20 18.6916V11.9626C21.4452 11.9626 22.6168 10.791 22.6168 9.3458C22.6168 7.90056 21.4452 6.72898 20 6.72898ZM33.271 20C33.271 18.5548 32.0994 17.3832 30.6542 17.3832V10.6542C35.8158 10.6542 40 14.8385 40 20C40 25.1616 35.8158 29.3458 30.6542 29.3458C25.4926 29.3458 21.3084 25.1616 21.3084 20H28.0374C28.0374 21.4452 29.209 22.6168 30.6542 22.6168C32.0994 22.6168 33.271 21.4452 33.271 20ZM9.3458 22.6168C7.90056 22.6168 6.72898 21.4452 6.72898 20C6.72898 18.5548 7.90056 17.3832 9.3458 17.3832C10.791 17.3832 11.9626 18.5548 11.9626 20H18.6916C18.6916 14.8385 14.5073 10.6542 9.3458 10.6542C4.18426 10.6542 0 14.8385 0 20C0 25.1616 4.18426 29.3458 9.3458 29.3458V22.6168ZM20 33.271C21.4452 33.271 22.6168 32.0994 22.6168 30.6542H29.3458C29.3458 35.8158 25.1616 40 20 40C14.8385 40 10.6542 35.8158 10.6542 30.6542C10.6542 25.4926 14.8385 21.3084 20 21.3084V28.0374C18.5548 28.0374 17.3832 29.209 17.3832 30.6542C17.3832 32.0994 18.5548 33.271 20 33.271Z"
        fill="#E89A12"
      />
    </svg>
  );
};

export const ArrowRight = (props: any) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6338 5.92993L20.7038 11.9999L14.6338 18.0699"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.70361 12H20.5336"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
